"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var SnackbarContentTheme = function SnackbarContentTheme(colors) {
  return {
    defaultProps: {
      elevation: 3
    },
    styleOverrides: {
      root: {
        padding: 0,
        backgroundColor: 'currentColor',
        borderRadius: 'inherit',
        alignItems: 'stretch'
      },
      message: {
        padding: 0,
        flex: '1 1 auto'
      },
      action: {
        width: '100%',
        paddingLeft: 0,
        marginRight: 0,
        marginLeft: 0,
        justifyContent: 'space-around',
        '& .MuiButton-root': {
          width: '100%',
          flex: 1,
          fontWeight: '500',
          fontFamily: 'Barlow',
          borderRadius: 0,
          '&:hover': {
            background: colors.bleuDigital05
          },
          '&:active': {
            background: colors.bleuDigital10
          },
          '&:first-of-type': {
            borderBottomLeftRadius: '8px'
          },
          '&:last-of-type': {
            borderBottomRightRadius: '8px'
          }
        }
      }
    }
  };
};

var _default = SnackbarContentTheme;
exports["default"] = _default;